import React, { Component } from 'react'
import { Button as ButtonComponent } from 'react-bootstrap'
import { isReadOnly } from 'utilities/JSUtil'
import './Button.scss'

class Button extends Component {

  render() {

    let className = 'button-main'
    if (this.props.role === 'secondary') {
      className += ' secondary'
    }

    if (this.props.role === 'link') {
      className += ' button-link'
    }

    if (this.props.className) {
      className += ' ' + this.props.className
    }

    return (
      <ButtonComponent
        {...this.props}
        className={className}
        variant='secondary'
        disabled={this.props.overridedisabledflag === 'true' ? false : (isReadOnly() || this.props.disabled)}>
        {this.props.name}
      </ButtonComponent>
    )
  }
}

export default Button